/**
 * Presentation shortlist sizes for local-adapter panels (plan §3.3).
 *
 * These are product constants, not generator knobs — they live in `constants/`
 * so a reader looking for panel sizes finds them next to the other closed
 * roster, and so adapters do not invent a second home for the same kind of
 * number. Wire-side MAX bounds (e.g. CORRELATION_EXTREMES_MAX in contracts)
 * stay in contracts; these are the product defaults under those caps.
 */
/** Sector leaders shown on the stock screen (demo:1046). */
export const PEER_PANEL_SIZE = 9;
/** Most/least-correlated shortlists beside the diversification groups. */
export const CORRELATION_EXTREMES_SIZE = 5;
/** Correlation grid is the sector's largest names — 10×10 is the readable ceiling. */
export const MATRIX_SIZE = 10;
/** "Top 10 · total return" table on the sector screen. */
export const MOVERS_SIZE = 10;
